export const isInput = (element: Element) => {
  return (
    element.tagName === 'INPUT' ||
    element.tagName === 'TEXTAREA' ||
    (element as HTMLElement).isContentEditable
  );
};

export const convertToNumberInputValue = (value: string, decimals = 6) => {
  if (value === '.') {
    return '0.';
  }

  // Allow only numbers and one dot
  const newValue = value
    .replace(/[^0-9.]/g, '') // Remove non-numeric characters except the dot
    .replace(/(\..*)\./g, '$1') // Allow only one dot
    .replace(/^\./, ''); // If starts with a dot, replace with empty string

  // Limit to 6 decimal places
  const parts = newValue.split('.');
  if (parts[1] && parts[1].length > decimals) {
    parts[1] = parts[1].substring(0, decimals);
  }

  return parts.join('.');
};

export const handleNumberInputOnInput =
  (decimals = 6) =>
  (event: React.FormEvent<HTMLInputElement>) => {
    const input = event.target as HTMLInputElement;
    const value = convertToNumberInputValue(input.value, decimals);

    input.value = value;
  };
